import classNames from 'classnames';
import { DetailedHTMLProps, HTMLAttributes } from 'react';

export default function HeaderTitle({
  className,
  children,
  ...props
}: DetailedHTMLProps<HTMLAttributes<HTMLHeadingElement>, HTMLHeadingElement>) {

  return (
    <h1
      className={classNames('py-1.5 h-10 flex items-center', className)}
      {...props}
    >
      {children}
    </h1>
  );
}
